<template lang="pug">
div(
    :id="id"
    :class="[size]"
    class="transactionlink-component-text-title"
    :style="`text-align: ${alignment}`"
    v-html="markedContent"
)
</template>

<script setup>
import { computed } from 'vue'
import marked from 'widget-components/utilities/marked'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    content: String,
    options: Object,
})

const markedContent = computed(() => marked(props.content))
const size = computed(() => props?.options?.size?.toLowerCase() || '')
const alignment = computed(() => props?.options?.alignment || '')
</script>

<style lang="sass" scoped>
@import "./TextTitle.sass"
</style>
